import breakPoints from 'helpers/Styles';
import Image from 'next/image';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import {
  FacebookIcon,
  FacebookShareButton,
  RedditIcon,
  RedditShareButton,
  TwitterIcon,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
} from 'react-share';

const ShareButtons = ({
  toggleShare,
  url = '',
  type,
  handleChangeEmail,
  handleSendMail,
  email,
  mail,
  errorMail,
}) => {
  const [urlCopied, setUrlCopied] = useState(false);

  const handleCopyLink = () => {
    navigator.clipboard.writeText(url);
    setUrlCopied(true);
  };

  const title = 'Aftershock PC';
  const twitterHandle = 'aftershock';
  const tags = ['aftershock', 'custom-pc'];

  useEffect(() => {
    const timer = setTimeout(() => {
      if (urlCopied) {
        setUrlCopied(false);
      }
    }, 1000);
    return () => clearTimeout(timer);
  }, [urlCopied]);

  return (
    <>
      <div className="share">
        <div className="card_head">
          <div className="main-head">
            <h1>SHARE YOUR RESULT</h1>
          </div>
          <div className="close-icon">
            <button
              onClick={toggleShare}
              className="button-div"
              type="button"
              style={{ float: 'right' }}
            >
              <Image draggable={false} 
                src="https://cdn.shopify.com/s/files/1/0522/3320/7988/files/icon-close.png?v=1714038756"
                width="24px"
                height="24px"
                alt="close icon"
              />
            </button>
          </div>
        </div>
        <div className="main-inr-paddding">
          <h3>Share to social media: </h3>
          <div className="socials">
            <FacebookShareButton url={url}>
              <FacebookIcon size={40} round />
            </FacebookShareButton>

            <TwitterShareButton
              url={url}
              title={title}
              via={twitterHandle}
              hashtags={tags}
            >
              <TwitterIcon size={40} round />
            </TwitterShareButton>

            <WhatsappShareButton url={url} title={title}>
              <WhatsappIcon size={40} round />
            </WhatsappShareButton>

            <RedditShareButton url={url} title={title}>
              <RedditIcon size={40} round />
            </RedditShareButton>
          </div>

          <h3>Copy link to clipboard</h3>
          <div className="copyLink">
            <div className="copy-input">
              <input type="text" value={url} disabled className="inputLink" />
            </div>
            <div className="copy">
              <button type="button" className="button" onClick={handleCopyLink}>
                {urlCopied ? 'COPIED' : 'COPY'}
              </button>
              <div className="copy-icon">
                <Image draggable={false} 
                  src="https://cdn.shopify.com/s/files/1/0522/3320/7988/files/copy.png?v=1713944090"
                  alt="copy icon"
                  layout="fixed"
                  width={30}
                  height={30}
                />
              </div>
            </div>
          </div>
          {type === 'rts' && (
            <>
              <h3>Email me my result</h3>
              <div className="copyLink">
                <div className="copy-input">
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => handleChangeEmail(e.target.value)}
                    className="inputLink"
                    placeholder="Enter your email address..."
                  />
                </div>
                <div className="copy">
                  <button
                    type="button"
                    className={`button ${mail && 'btn-success'}`}
                    onClick={() => handleSendMail(url)}
                  >
                    {mail ? 'Sent' : 'Send'}
                  </button>
                  <div className="copy-icon">
                    <svg
                      width="48"
                      height="48"
                      viewBox="0 0 48 48"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M0 0H44C46.2091 0 48 1.79086 48 4V44C48 46.2091 46.2091 48 44 48H0V0Z"
                        fill="#242424"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M24 16L22.59 17.41L28.17 23H16V25H28.17L22.59 30.59L24 32L32 24L24 16Z"
                        fill="#E4E4E4"
                      />
                    </svg>
                  </div>
                </div>
              </div>
              {mail && (
                <div className="alert-msg alert-msg-success">
                  Email sent successfully !
                </div>
              )}
              {errorMail && (
                <div className="alert-msg alert-msg-danger">
                  Invalid Email !
                </div>
              )}
            </>
          )}
        </div>
        <div className="main-footer">
          <h4>
            NEED HELP? <span>TALK TO AN EXPERT</span>
          </h4>
        </div>
      </div>

      <style global jsx>
        {`
          .Results_modalContent__5J5kQ {
            max-width: 640px !important;
            height: 500px !important;
            padding: 0 !important;
          }
          .react-share__ShareButton {
            margin-right: 30px;
            padding: 0 12px;
          }
          .inputLink {
            padding: 0 12px;
          }
          @media (max-width: ${breakPoints.small}) {
            .Results_modalContent__5J5kQ {
              max-width: 350px !important;
              padding: 0 !important;
            }
          }
        `}
      </style>
      <style jsx>
        {`
          .btn-success {
            color: #fff !important;
            background-color: #2f9343 !important;
            border-color: #28a745 !important;
          }
          .alert-msg-danger {
            color: #721c24;
            background-color: #f8d7da;
            border-color: #f5c6cb;
          }
          .alert-msg-success {
            color: #155724;
            background-color: #d4edda;
            border-color: #c3e6cb;
          }
          .alert-msg {
            margin: 10px 0;
            position: relative;
            padding: 0.75rem 1.25rem;
            margin-bottom: 1rem;
            border: 1px solid transparent;
            border-radius: 0.25rem;
          }
          .card_head {
            background: #141414;
            border-radius: 2px 2px 0px 0px;
          }
          .share {
            width: 100%;
            margin: 0 auto;
            padding: 0 0px;
            background: black;
          }
          .main-inr-paddding {
            padding: 10px 20px;
          }
          .main-head h1 {
            font-style: normal;
            font-weight: 400;
            font-size: 31px;
            line-height: 40px;
            color: #e4e4e4;
            background: transparent !important;
          }
          .main-footer span {
            text-decoration: underline;
          }
          .card_head {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 20px;
          }
          .main-footer {
            text-align: center;
            background: #141414;
            border-radius: 2px 2px 0px 0px;
            height: 56px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 20px;
          }
          .main-footer h4 {
            font-weight: 600;
            font-size: 13px;
            line-height: 20px;
            text-align: center;
            color: #949494;
          }
          .share h3 {
            color: #e4e4e4;
            font-family: 'Roboto-Medium';
            font-size: 16px;
            letter-spacing: 0;
            line-height: 28px;
          }
          .copyLink {
            height: 48px;
            border-radius: 2px;
            display: flex;
            justify-content: space-between;
          }
          .copy-input {
            border: 1px solid #242424;
            width: 484px !important;
            display: flex;
            height: 48px !important;
            justify-content: center;
            background-color: #141414 !important;
          }
          input {
            display: block;
            width: 484px;
            height: 48px !important;
            background-color: #141414 !important;
            outline: none;
            border: 0px;
            margin-right: 30px;
          }
          .copy {
            width: 160px !important;
            display: flex;
            justify-content: space-between;
          }
          .button {
            float: right;
            height: 48px;
            width: 100px;
            border-radius: 2px 0 0 2px;
            background-color: #950810;
            outline: none;
            border: 0px;
            color: #e4e4e4;
            font-family: 'Roboto-Medium';
            font-size: 16px;
            font-weight: bold;
            letter-spacing: 0;
            line-height: 24px;
            margin-left: 20px;
          }
          .copy-icon {
            height: 48px;
            width: 60px;
            border-radius: 0 2px 2px 0;
            background-color: #222222;
            display: flex;
            justify-content: center;
            align-items: center;
          }
          .copyLink input {
            width: 100%;
            color: #e4e4e4;
            background-color: #000;
          }
          .socials {
            display: flex;
            gap: 10px;
          }
          @media (max-width: ${breakPoints.small}) {
            .share {
              width: 100%;
              margin: 0 auto;
            }
            .main-head h1 {
              font-size: 16px !important;
            }
            .socials {
              gap: 3px !important;
            }
            .card_had {
              height: 40px !important;
            }
            .copyLink {
              width: 100% !important;
              height: auto !important;
              flex-direction: column;
            }
            .copy-input {
              width: 100% !important;
            }
            .copy {
              width: 100% !important;
              margin-top: 15px !important;
            }
            .copy .button {
              width: 90% !important;
              margin-left: 0 !important;
              height: 40px !important;
            }
            .copy-icon {
              height: 40px !important;
            }
            .share h3 {
              font-size: 15px !important;
              line-height: 10px !important;
            }
            .main-footer {
              height: 40px !important;
            }
          }
        `}
      </style>
    </>
  );
};

ShareButtons.propTypes = {
  url: PropTypes.string,
};

export default ShareButtons;
